import { useEffect, useState } from "react";
import { useAppSelector } from "../../../../../stateManagement/hooks/redux";
import TimeMark from "./TimeMark";
import { useDispatch } from "react-redux";
import { LegendChip } from "./LegendChip";
import { setTime } from "../../../../../stateManagement/reducers/maps/MapGismeteoPrecipitationSlice";

function generateTimeMarks() {
    const now = new Date();

    // Округляем текущее время вниз до ближайших 10 минут
    now.setMinutes(Math.floor(now.getMinutes() / 10) * 10, 0, 0);

    const timeMarks = [];

    // Добавляем 2 шага назад
    for (let i = 2; i > 0; i--) {
        const past = new Date(now.getTime() - i * 10 * 60 * 1000);
        const timeMark = {
            time: past,
            caption: formatTime(past)
        }
        timeMarks.push(timeMark);
    }

    // Добавляем "сейчас" и 14 шагов вперёд
    for (let i = 0; i <= 14; i++) {
        const future = new Date(now.getTime() + i * 10 * 60 * 1000);
        const timeMark = {
            time: future,
            caption: formatTime(future)
        }
        timeMarks.push(timeMark);
    }

    return timeMarks;
}

// Форматирование времени в строку "HH:mm"
function formatTime(date: Date) {
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
}

type TimeMark = {
    time: Date,
    caption: string
}

export default function GismeteoPrecipitationOverlay() {
    const dispatch = useDispatch()
    const [timeMarks, setTimeMarks] = useState<TimeMark[]>(() => generateTimeMarks());
    const timeMarkIndex = useAppSelector(state => state.maps.gismeteoPrecipitation.timeMarkIndex)

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeMarks(generateTimeMarks());
        }, 5 * 60 * 1000); // каждые 5 минут

        return () => clearInterval(interval);
    }, []);

    function changeTimeWithWheel(event: React.WheelEvent<HTMLDivElement>) {
        const direction = event.deltaY > 0 ? 1 : -1;
        const newIndex = timeMarkIndex + direction;
        const newTime = timeMarks[newIndex]?.time;

        if (newTime && newIndex >= 0 && newIndex <= 18) {
            dispatch(setTime({ time: newTime.toISOString(), timeMarkIndex: newIndex }));
        }
    }

    return (
        <div className="map-overlay map-overlay-gismeteo-precipitation" onWheel={changeTimeWithWheel}>
            <div className="map-gismeteo-precipitation-legend">
                <LegendChip caption="Осадки" backgroundImage="linear-gradient(90deg, #3bf, #4040bf)" color="white" />
                <LegendChip caption="Гроза" backgroundColor="#c941fc" color="white" />
                <LegendChip caption="Град" backgroundColor="#fbaf1d" color="black" />
            </div>
            {timeMarks.map(({ time, caption }: any, index) => <TimeMark key={index} time={time} caption={caption} index={index} active={index === timeMarkIndex} />)}
        </div>
    )
}
